module.exports = __webpack_public_path__ + "img/Bitdefender-GravityZone.ad952fe.svg";